if (
  document.querySelector(".component-video") ||
  document.querySelector(".component-video-product")
) {
  let videos = document.querySelectorAll(".component-video__video-container");
  if (videos.length === 0) {
    videos = document.querySelectorAll(
      ".component-video-product__video-container"
    );
  }

  let currentlyPlaying = null;

  videos.forEach((video) => {
    let buttonPlay =
        video.querySelector(".component-video__play") ||
        video.querySelector(".component-video-product__play"),
      singleVideo =
        video.querySelector(".component-video__video") ||
        video.querySelector(".component-video-product__video");

    if (buttonPlay && singleVideo) {
      singleVideo.pause();
      singleVideo.muted = true;

      buttonPlay.addEventListener("click", () => {
        if (currentlyPlaying && currentlyPlaying !== singleVideo) {
          currentlyPlaying.pause();
          currentlyPlaying
            .closest(
              ".component-video__video-container, .component-video-product__video-container"
            )
            .querySelector(
              ".component-video__play, .component-video-product__play"
            )
            .classList.remove("hidden");
        }

        buttonPlay.classList.toggle("hidden");

        if (buttonPlay.classList.contains("hidden")) {
          singleVideo.play();
          singleVideo.muted = false;
          currentlyPlaying = singleVideo;
        } else {
          singleVideo.pause();
          currentlyPlaying = null;
        }
      });
    }
  });
}
